var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TryFramework"},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("增加试戴")]),_c('TryFrameworkContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }